import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router'

import { DeliveryPaymentTabs } from '@features/delivery-payment-tabs'

import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function DeliveryPaymentLayout () {
  const { t } = useTranslation('common')

  return (
    <Container className={styles.container}>
      <Wrapper className={styles.wrapper}>
        <div className={styles.page}>
          <Breadcrumbs
            className={styles.breadcrumbs}
            links={[
              {
                title: t('delivery-payment'),
              },
            ]}
          />
          <DeliveryPaymentTabs />
          <Outlet />
        </div>
      </Wrapper>
    </Container>
  )
}
